import { State } from '../state.interface';
import * as Actions from '../actions';
import { assocPath } from 'ramda';

export const setDefaultValueValidationReducer = (state: State, action: Actions.SetDefaultValueValidation) =>
  assocPath<any, State>(['validation', 'default_value'], action.payload, state);
